export class AppConstants {
  static NAVBAR_MAXWIDTH: number = 960;
  static NAVBAR_HEIGHT: number = 64;
  static GRIDPAGE_WIDTH: number = 960;
}
